// extracted by mini-css-extract-plugin
export var background = "image-gallery-module--background--49ad4";
export var chevron = "image-gallery-module--chevron--4de8c";
export var closeButton = "image-gallery-module--closeButton--f716d";
export var container = "image-gallery-module--container--f8dcb";
export var ctaContainer = "image-gallery-module--ctaContainer--1013f";
export var galleryGrid = "image-gallery-module--galleryGrid--cf2c6";
export var galleryImage = "image-gallery-module--galleryImage--62836";
export var headline = "image-gallery-module--headline--8c42c";
export var imageContainer = "image-gallery-module--imageContainer--33642";
export var imageCounter = "image-gallery-module--imageCounter--5fe5e";
export var imageOverlay = "image-gallery-module--imageOverlay--62717";
export var imageWrapper = "image-gallery-module--imageWrapper--1b3d1";
export var modal = "image-gallery-module--modal--7a6a4";
export var modalCaption = "image-gallery-module--modalCaption--364d6";
export var modalContent = "image-gallery-module--modalContent--bb926";
export var modalImage = "image-gallery-module--modalImage--ddfc0";
export var navButton = "image-gallery-module--navButton--6f82a";
export var nextButton = "image-gallery-module--nextButton--25234";
export var prevButton = "image-gallery-module--prevButton--2d31e";
export var viewGalleryButton = "image-gallery-module--viewGalleryButton--540d4";
export var wrapper = "image-gallery-module--wrapper--886e3";